import { render, staticRenderFns } from "./logged-layout.vue?vue&type=template&id=41bdac96&"
import script from "./logged-layout.vue?vue&type=script&lang=js&"
export * from "./logged-layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports